"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductDetails = void 0;

var _logger = _interopRequireDefault(require("../../logger"));
/* eslint import/prefer-default-export: "off" */


var productIntroductionUrl = 'https://introduction.products.cimpress.io/v3/mcpSkus/';

var getProductDetails = function getProductDetails(onGetAccessToken, mcpSku) {
  var accessToken = onGetAccessToken();
  var headers = new Headers({
    Accept: 'application/json',
    Authorization: "Bearer ".concat(accessToken)
  });
  var options = {
    method: 'GET',
    mode: 'cors',
    headers: headers
  };
  return fetch("".concat(productIntroductionUrl).concat(mcpSku), options).then(function (res) {
    if (res.ok) {
      return res.json();
    }

    _logger.default.warn("unable to fetch sku [".concat(mcpSku, "] from products [").concat(productIntroductionUrl, "]"), 'introduction');

    throw res;
  });
};

exports.getProductDetails = getProductDetails;